export interface PaypalInfoResponse {
	subscription_status: SubscriptionStatus;
	subscription_plan_type: 'monthly' | 'yearly' | '';
	created_time: string;
	free_trial: string;
	is_currently_in_free_trial?: string;
	next_billing_time: string;
	last_billing_time: string;
	start_time: string;
	subscription_id?: string;
	plan_id?: string;
}

export interface PaypalInfoReturnValue {
	paypalInfoResponse: PaypalInfoResponse;
	billingTimePassed: number;
	billingTotalDays: number;
	billingProgressPercentage: number;
	subscriptionPlan: string;
	subscriptionStatus: string;
	subscriptionText: string;
	vouchersDates: VoucherDate[];
	whatIsHappening: { hasVouchers: boolean; hasPremium: boolean };
	vouchersInfoResponse: VoucherResponse[];
	nextBillingTime: string;
}

export interface VoucherDate {
	start: string;
	end: string;
	daysPassed: number;
	duration: number;
	code: string;
	status: string;
	endDateInTimestamp: number;
}

export interface VoucherResponse {
	iat: string;
	aat: string;
	code: string | null;
	duration: number;
	status: string;
	type: string;
	nbf?: number;
	exp?: number;
	uid: number;
}

export enum SubscriptionStatus {
	Active = 'ACTIVE',
	Cancelled = 'CANCELLED',
	Unknown = '',
}

export enum UserPremiumStatus {
	BASIC_FROM_BF_DURING = 'BASIC_FROM_BF_DURING',
	BASIC_DEFAULT = 'BASIC_DEFAULT',
	PREMIUM_FROM_BF_DURING = 'PREMIUM_FROM_BF_DURING',
	PREMIUM_FROM_BF_AFTER = 'PREMIUM_FROM_BF_AFTER',
	PREMIUM_DEFAULT = 'PREMIUM_DEFAULT',
}
